import React from 'react';
import '../styles/Avatar.css';

const PALETTE = ['#CD3E3D', '#3E7CCD', '#3ECD8E', '#CD9A3E', '#8E3ECD', '#3ECDC2'];

const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return ((parts[0][0] || '') + (parts.at(-1)[0] || '')).toUpperCase();
};

const colorFor = (seed = '') => {
  let hash = 0;
  for (const ch of seed) hash = ch.charCodeAt(0) + ((hash << 5) - hash);
  return PALETTE[Math.abs(hash) % PALETTE.length];
};

// user: { _id, fullName, profilePictureUrl }
// size: diameter in px. Omit to size via the CSS custom property
// --avatar-size (set on an ancestor), letting a media query control it.
const Avatar = ({ user, size, className = '', style = {} }) => {
  const dimension = size != null ? `${size}px` : 'var(--avatar-size, 40px)';
  const fontSize = size != null ? size * 0.4 : 'calc(var(--avatar-size, 40px) * 0.4)';

  const commonStyle = {
    width: dimension,
    height: dimension,
    borderRadius: '50%',
    flexShrink: 0,
    ...style,
  };

  if (user?.profilePictureUrl) {
    return (
      <img
        src={user.profilePictureUrl}
        alt={`${user.fullName}'s profile`}
        className={`avatar-circle ${className}`}
        style={{ ...commonStyle, objectFit: 'cover' }}
      />
    );
  }

  return (
    <div
      className={`avatar-circle ${className}`}
      style={{
        ...commonStyle,
        background: colorFor(user?._id || user?.fullName),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 600,
        fontSize,
      }}
    >
      {getInitials(user?.fullName)}
    </div>
  );
};

export default Avatar;
